export function makeGenerateRadioId(attributeName) {
    return function generateRadioId(attributeValue, context) {
        const selectionText = `${attributeName}-selection:${attributeValue}`;
        return context ? `${context}|${selectionText}` : selectionText;
    };
}
//# sourceMappingURL=makeGenerateRadioId.js.map